/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { ga4_AdClick, ga4_AdView } from 'common/libs/googleTagManager'
const SearchBar = () => {
    const [advKeyword, setAdvKeyword] = useState(null)

    const onSubmit = useCallback(() => {
        if (!advKeyword.ment_keyword) return

        // 검색광고 클릭 태그
        ga4_AdClick(advKeyword)
        // ua_AdClick(advKeyword)
        // uaEventClick(
        //     advKeyword.mall_name + '_' + advKeyword.idx_b_manager,
        //     advKeyword.nm_ad,
        //     advKeyword.ad_id,
        //     'null_null'
        // )
        window.location.href = advKeyword.lnk_ad
    }, [advKeyword])

    const onClickInput = useCallback(() => {
        window.location.href = process.env.REACT_APP_SEARCH_URL
    }, [])

    const fetchAdvKeyword = async () => {
        const url = `${process.env.REACT_APP_API_URL}/front/v2/ads/PAG002`
        try {
            const data = await axios.get(url)
            setAdvKeyword(data.data.result)
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchAdvKeyword()
    }, [])

    useEffect(() => {
        if (advKeyword !== null && advKeyword.ad_id !== undefined) {

            // 검색광고 노출 태그
            ga4_AdView(advKeyword)
            // ua_AdView(advKeyword)
            // uaEventView(
            //     advKeyword.mall_name + '_' +advKeyword.idx_b_manager,
            //     advKeyword.nm_ad,
            //     advKeyword.ad_id,
            //     'null_null'
            // )
        }
    }, [advKeyword])

    return (
        <Style className="header_component_searchbar">
            <div
                type="text"
                className="search_input"
                onClick={onClickInput}
            >
                {/* {advKeyword && (advKeyword.ment_keyword ? advKeyword.ment_keyword : '')} */}
                {advKeyword && <marquee scrolldelay={120}>{(advKeyword.ment_keyword ? advKeyword.ment_keyword : '')}</marquee>}
            </div>
            <button type="button" className="search_button" onClick={onSubmit}>
                <i className="icon-bottom_zoomlens" />
            </button>
        </Style>
    )
}

const Style = styled.div`
    position: relative;
    width: calc(100% - 174px);
    height: 36px;
    border-radius: 18px;
    border: 1px solid #418ded;
    margin: 0 64px 0 110px;

    .search_button {
        position: absolute;
        top: 6px;
        right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: 0px;
        width: 24px;
        height: 24px;
        color: #418ded;
        font-size: 16px;
    }
    .search_input {
        margin: 0 0 0 22px;
        padding: 6px 0;
        height: 34px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 700;
        border: 0;
        background: #fff;
        width: calc(100% - 60px);
        cursor: pointer;

        marquee {
            font-size: 14px;
        }
    }
    .reset_button {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 6px;
        right: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        background: none;

        span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            background: #d6d6d6;
            color: #fff;
            border-radius: 8px;
            font-size: 10px;

            i {
                display: block;
                transform: scale(0.9)
            }
        }
    }
`

export default SearchBar



// WEBPACK FOOTER //
// ./src/m_header/components/search/search_bar.js